import React from "react";
import { Link } from "gatsby";
import SubscriptionBadge, { SubscriptionBadgeSize } from "../badge/subscription-badge";
import { replaceQuotationMarksWithGuillemets } from "../../util/format/guillemets";
var SidebarItem = function SidebarItem(_ref) {
    var to = _ref.to, title = _ref.title, articleId = _ref.articleId, visibility = _ref.visibility, _ref$read = _ref.read, read = _ref$read === void 0 ? false : _ref$read, children = _ref.children, color = _ref.color, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$isEdition = _ref.isEdition, isEdition = _ref$isEdition === void 0 ? true : _ref$isEdition, _ref$isEvent = _ref.isEvent, isEvent = _ref$isEvent === void 0 ? false : _ref$isEvent;
    var textColor = color ? "text-makro" + color : "text-makroGreyDark";
    return /*#__PURE__*/ React.createElement(Link, {
        to: to,
        className: "block pl-4 lg:pl-6 pr-4 mb-4 " + className + " " + (read ? "text-gray-500" : textColor),
        activeClassName: textColor
    }, /*#__PURE__*/ React.createElement("span", {
        className: "h0 block font-medium text-xl mb-1 md:text-2xl"
    }, !isEvent && /*#__PURE__*/ React.createElement(SubscriptionBadge, {
        size: SubscriptionBadgeSize.SIDEBAR,
        articleId: articleId,
        visibility: visibility,
        isEdition: isEdition
    }), replaceQuotationMarksWithGuillemets(title)), children);
};
export default SidebarItem;
